// extracted by mini-css-extract-plugin
export default {"container":"DoKm5","noWrapContainer":"PF86R","logo":"XeGrE","infoButton":"LdjRv","dark":"JVEpm","light":"zMHVR"};